import React from 'react';

const LensEuroIcon = ({ size = 1.1, className = '' }) => {
  const px = size * 24;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={px}
      height={px}
      className={className}
      fill="currentColor"
    >
      <path d="M15.5 14H14.71L14.44 13.73C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.44L14 14.71V15.5L19 20.5 20.5 19 15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z" />
      <text x="9.5" y="10.1" textAnchor="middle" dominantBaseline="central"
        fontFamily="Arial, sans-serif" fontSize="7" fontWeight="bold"
        fill="currentColor">€</text>
    </svg>
  );
};

export default LensEuroIcon;